import { z } from 'zod';
import { CommandType } from '../types/device.js';
// ACTUATE 파라미터 — kind 기준 분기 (relay | pwm)
export const ActuateParamsSchema = z.discriminatedUnion('kind', [
    z.object({
        kind: z.literal('relay'),
        channel: z.string().min(1).max(32),
        state: z.enum(['on', 'off']),
    }),
    z.object({
        kind: z.literal('pwm'),
        channel: z.string().min(1).max(32),
        duty: z.number().int().min(0).max(100),
    }),
]);
// API 요청 본문 — type 기준 분기
export const IssueCommandSchema = z.discriminatedUnion('type', [
    z.object({ type: z.literal(CommandType.ACTUATE), params: ActuateParamsSchema }),
    z.object({ type: z.literal(CommandType.REBOOT) }),
    z.object({ type: z.literal(CommandType.REPORT) }),
    z.object({ type: z.literal(CommandType.CAPTURE) }),
]);
// 결과(ACK) 페이로드 검증
export const CommandResultPayloadSchema = z.object({
    commandId: z.string().uuid(),
    ok: z.boolean(),
    result: z.record(z.unknown()).optional(),
    error: z.string().max(500).optional(),
    at: z.string().datetime(),
});
//# sourceMappingURL=command.js.map